import {
  Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box,
  Button,
  Collapse,
  useDisclosure,
} from '@chakra-ui/react';
import BackgroundStyles from './backgroundStyles';
import FormLabelStyles from './formLabelStyles';
import InputSyles from './inputSyles';
import LayoutStyles from './layoutStyles';
import FieldStyles from './fieldStyles';

const AdvanvedSettings = ({ design }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <Button variant="ghost" size="sm" onClick={onToggle} colorScheme="blue">
        {isOpen ? 'Hide' : 'Show'}
        {' '}
        advanced settings
      </Button>
      <Collapse
        in={isOpen}
        animateOpacity
        style={{ width: '100%', overflow: 'visible' }}
        transition={{ exit: { delay: 0, duration: 0 }, enter: { duration: 0 } }}
        unmountOnExit
      >
        <Accordion defaultIndex={[0]} allowMultiple fontSize="sm" minW="100%">
          <AccordionItem>
            <h2>
              <AccordionButton fontSize="sm" px="0">
                <Box as="span" flex="1" textAlign="left" fontWeight="bold">
                  Layout
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4} px="0">
              <LayoutStyles design={design} />
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton fontSize="sm" px="0">
                <Box as="span" flex="1" textAlign="left" fontWeight="bold">
                  Background
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4} px="0">
              <BackgroundStyles design={design} />
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton fontSize="sm" px="0">
                <Box as="span" flex="1" textAlign="left" fontWeight="bold">
                  Fields
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4} px="0">
              <FormLabelStyles design={design} />
              <InputSyles design={design} />
              <FieldStyles design={design} />
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Collapse>
    </>
  );
};
export default AdvanvedSettings;
